{#if $sliderData}
  <div class="weather-rotator">
    <svelte:component
      this="{Carousel}"
      let:showPrevPage
      let:showNextPage
      let:currentPageIndex
      bind:this="{$carouselInstance}"
      dots="{false}"
      particlesToShow="{8}"
      particlesToScroll="{1}"
      infinite="{false}"
    >
      <!--swiper-button-disabled-->
      <!-- <div class="slider-page"> -->
      <!--  <div slot="prev" class="swiper-button-next swiper-button-white"></div> -->

      {#each $sliderData as time}
        <div
          class="weather-rotator-item d-flex flex-column align-items-center font-size-sm"
          on:click="{(e) => clickOnHour(time)}"
        >
          <span class:active="{time.active === true}">
            <div class="font-weight-bold text-center pt-1">
              {#if time.showDayName}
                {time.dateByName},
              {/if}
              {time.time}
            </div>
            <img
              class="weather-icon img-fluid"
              src="https://img.rtvslo.si/_static/novi/bootstrap/public/img/weather-widget/{utils.getDisplayIcon(
                time.icon,
                time.time,
                time.sunriseHour,
                time.sunsetHour,
              )}.svg"
              alt="{time.icon}"
            />
            <div class="font-weight-light text-center">
              {time.temperature} °C
            </div>
          </span>
        </div>
      {/each}
    </svelte:component>
  </div>
{/if}

<script lang="ts">
  import Carousel from "./svelte-carousel/Carousel/Carousel.svelte";
  import { get } from "svelte/store";
  import { weatherStore } from "../store";
  import { cityOptions } from "../services/CityOptions";
  import { onMount } from "svelte";
  import { iconConverter } from "./../services/IconConverter";
  import { utils } from "../services/Utils";
  const {
    selectedCity,
    selectedTime,
    carouselInstance,
    firstPagesGroup,
    lastPagesGroup,
    currentIndex,
    storedDate,
    sliderData,
  } = weatherStore;

  let _selectedCity = get(selectedCity);
  let _selectedTime = get(selectedTime);
  let Carousel; // for saving Carousel component class
  onMount(async () => {
    const module = await import("./svelte-carousel/Carousel/Carousel.svelte");
    Carousel = module.default;
    clickOnHour($sliderData[0]);
  });

  function clickOnHour(time) {
    currentIndex.set(time.index);
    cityOptions.changeHour(time);
  }
</script>
